import React from "react";
import { useNavigation } from "@react-navigation/native";
import { useDietSupplements } from "../DietSupplementsContext";
import { useQueuedPatientUpdate } from "@src/packages/patients/sync/usePatientSync";
import { useTranslations } from "@src/packages/i18n";
import { transformDietSupplementsStateToRequest } from "../transformDietSupplementsStateToRequest";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@src/packages/medical-history/components/BaseCompleteScreen";

export function DietSupplementsCompleteScreen() {
  const t = useTranslations();
  const { state } = useDietSupplements();
  const navigation = useNavigation();
  const { mutateAsync: updatePatient, isPending } = useQueuedPatientUpdate();

  const handleFinish = async () => {
    try {
      const payload = transformDietSupplementsStateToRequest(state);
      await updatePatient(payload);
      navigateToNextSection(navigation, "dietSupplements");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.lifestyle.diet_supplements.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "dietSupplements")}
      isSubmitting={isPending}
      onFinish={handleFinish}
    />
  );
}
